jQuery(function($) { 
  /**
   * Document show on load
   */
  $(document).ready(function() {
    $('body').show();
    sliderPrepare();
  });

  /**
   * Window resize
   */
  $(window).resize(function() {
    sliderPrepare();
  });

  /**
   * Modal
   */
  $(window)
    .on('show.bs.modal', function() { 
      $('html').addClass('modal-open');
    })
    .on('hidden.bs.modal', function() { 
      $('html').removeClass('modal-open');
    });

  /**
   * Navbar toggle
   */
  $(document).on('click', 'button.navbar-toggle', function() {
    var button = $(this);

    navbarToogle(button.data('target'));
  });
  $(document).on('click', '.menu-collapse.in a', function() {
    console.log('click');
    var button = $(this),
        menuId = button.parents('.menu-collapse').attr('id');

    navbarToogle('#'+ menuId);
  });

  function navbarToogle(navbar) {
    menu = $(navbar);
    var navbarId = menu.attr('id'),
        button = $('.navbar-toggle[data-target="#'+ navbarId +'"]'),
        body = $('html');

    if (button.attr('aria-expanded') == 'false') {
      body.addClass('navbar-toggle-open');
      button.attr('aria-expanded', 'true');
      menu.addClass('collapsing');
      
      setTimeout(function() {
        menu
          .removeClass('collapsing')
          .addClass('in');
      }, 500);
    } else {
      button.attr('aria-expanded', 'false');
      menu.removeClass('in');

      setTimeout(function() {
        
        body.removeClass('navbar-toggle-open');
        menu.removeClass('collapsing');
      }, 500);
    }
  }

  /**
   * Scroll to anchor in current page
   */
  $(document).on('click', 'ul.menu li.current-menu-item a', function(e) {
    var button = $(this),
        anchor = button.attr('href').match(/\/#(.*)$/);

    if (anchor) {
      e.preventDefault();
      var section = $('#'+ anchor[1]);

      if (section.length) {
        $('html, body').animate({
          scrollTop: section.offset().top
        }, 600);
      }
    }
  });

  /**
   * Prepare slider items height
   */
  function sliderPrepare() {
    var slider = $('section.slider');
    if (!slider.length)
      return;

    var items = $('.item', slider);
    if (items.length < 2)
      return;

    var maxHeight = 0;

    items.css('height', '');
    items.each(function() {
      var item = $(this);

      if (item.outerHeight() > maxHeight)
        maxHeight = item.outerHeight();
    });
    
    items.css('height', maxHeight);
  }
});

/**
 * Footer map init
 */
function initMap() {
  var mapContainer = document.getElementById('footer-map');

  if (!mapContainer)
    return;

  var mapCenter = typeof mapContainer.dataset.gm != 'undefined'
    ? {lat: parseFloat(JSON.parse(mapContainer.dataset.gm).lat), lng: parseFloat(JSON.parse(mapContainer.dataset.gm).lng)}
    : {lat: 52.402080, lng: 16.856234};

  var mapStyle = [
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {"color": "#e9e9e9"},
        {"lightness": 17}
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [
        {"color": "#f3f3f3"}
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [
        {"color": "#ffffff"},
        {"lightness": 17}
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
        {"color": "#ffffff"},
        {"lightness": 29},
        { "weight": 0.2}
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "geometry",
      "stylers": [
        {"color": "#ffffff"},
        {"lightness": 18}
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "geometry",
      "stylers": [
        {"color": "#ffffff"},
        {"lightness": 16}
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {"color": "#f5f5f5"},
        {"lightness": 21}
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {"color": "#dedede"},
        {"lightness": 21}
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {"visibility": "on"},
        {"color": "#ffffff"},
        {"lightness": 16}
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {"saturation": 36},
        {"color": "#333333"},
        {"lightness": 40}
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {"visibility": "off"}
      ]
    },
    {
      "featureType": "transit",
      "elementType": "geometry",
      "stylers": [
        {"color": "#f2f2f2"},
        {"lightness": 19}
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry.fill",
      "stylers": [
        {"color": "#fefefe"},
        { "lightness": 20}
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry.stroke",
      "stylers": [
        {"color": "#fefefe"},
        {"lightness": 17},
        {"weight": 1.2}
      ]
    }
  ];
  var markerIcon = {
    url: brThemeConfig.template_directory_uri +'/dist/img/marker.png'
  };

  var map = new google.maps.Map(mapContainer, {
    center: mapCenter,
    zoom: 16,
    disableDefaultUI: true,
    scrollwheel: false,
    styles: mapStyle
  });

  var marker = new google.maps.Marker({
    position: mapCenter,
    map: map,
    icon: markerIcon
  });

  google.maps.event.trigger(map, 'resize');
  google.maps.event.addDomListener(window, 'resize', function() {
    google.maps.event.trigger(map, 'resize');
    map.setCenter(mapCenter);
  });
  google.maps.event.addDomListener(document, 'ready', function() {
    google.maps.event.trigger(map, 'resize');
    map.setCenter(mapCenter);
  });
}